import { useState, useCallback, useRef } from "react"
import { fetchAuditLogs } from "../api/auditLogsApi"

export function useAuditLogs() {
  const [data, setData] = useState(null) // { audit_logs, meta }
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const abortRef = useRef(null)

  const fetch = useCallback(async (filters = {}) => {
    if (abortRef.current) abortRef.current.abort()
    abortRef.current = new AbortController()

    setLoading(true)
    setError(null)
    try {
      const result = await fetchAuditLogs(filters)
      setData(result)
    } catch (err) {
      if (err.name !== "AbortError") setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { data, loading, error, fetch }
}
